import { render } from "./solicitud.vue?vue&type=template&id=16698a8c"
import script from "./solicitud.vue?vue&type=script&lang=js"
export * from "./solicitud.vue?vue&type=script&lang=js"

import "./solicitud.vue?vue&type=style&index=0&id=16698a8c&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__